/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Loading"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={8}
 borderBottomRightRadius={8}
 borderTopLeftRadius={8}
 borderTopRightRadius={8}
 height={10}
 width={150}
/>
</div>
{children}
</React.Fragment>)
}